import { DecagonSignature } from './useGenerateSignature.interface';

import collectiveApi from 'modules/common/collectiveApi';

const generateDecagonSignature = async (id: string): Promise<DecagonSignature> => {
    const response = await collectiveApi.post<DecagonSignature>(`/ai/signature/decagon`, { id });
    return response.data;
};

export default generateDecagonSignature;
